// src/components/about/Contact.jsx
import React from 'react';
import { Building2, GlobeIcon } from 'lucide-react';
import ContactPerson from './ContactPerson';

const Contact = ({ data, people }) => {
  const organization = data.find(org => 
    org.name_normed === "jiri_hylmar_ico"
  );

  const guarantor = people?.find(person => 
    person.digital_horizon_role.some(role => role.name_normed === "contact_person")
  );

  if (!organization) {
    return (
      <div className="p-4 text-red-600">
        Organization not found
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Organization Details */}
      <div className="flex items-start">
        <Building2 className="h-6 w-6 text-blue-500 flex-shrink-0 mt-1" />
        <div className="ml-3">
          <h3 className="font-semibold text-gray-900">{organization.name}</h3>
          <p className="text-gray-600">{organization.description}</p>
        </div>
      </div>

      {/* Related Links */}
      {organization.values && organization.values.length > 0 && (
        <div className="space-y-4">
          <ul className="space-y-2">
            {organization.values.map((link, index) => (
              <li key={index} className="flex items-center">
                <GlobeIcon className="h-5 w-5 text-gray-400" />
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 text-blue-600 hover:text-blue-800"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Course Guarantor */}
      {guarantor && (
        <div className="space-y-2">
          <h4 className="font-medium text-gray-900">{guarantor.digital_horizon_role.find(role => role.name_normed === "contact_person").name}</h4>
          <ContactPerson person={guarantor} />
        </div>
      )}
    </div>
  );
};

export default Contact;